
export function createMapsURL(address, city, prov, postal) {
    if (!address || !city || !prov || !postal) {
        return null;
    }

    const mapsAddress = [address, city, prov, postal].filter(Boolean).join(',');
    const mapsLink = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(mapsAddress)}`;

    return mapsLink;
}